/**
 * If replacement value ends with dot, and the insertion also ends with dot, we should remove duplicate
 * thus we extend regex with dotReplacer
 */
const getDuplicateDotReplacer = (value) => (value[value.length - 1] === '.' ? '\\.?' : '');

/**
 * Replace all the {{insertionName}} insertions according to replaceTable key: value object
 */
export const replaceInsertionsByTable = (html, replaceTable) =>
  Object.keys(replaceTable).reduce((result, key) => {
    const dotReplacer = getDuplicateDotReplacer(replaceTable[key]);
    return result.replace(new RegExp(`{{${key}}}${dotReplacer}`, 'g'), replaceTable[key]);
  }, html);
